import React from 'react';
import ReactCheckboxGroup from 'react-checkbox-group';
import InputError from '../Error';

export interface CheckboxGroupProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  label?: string;
  error?: string;
  orientation?: 'horizontal' | 'vertical';
  options: {
    value: string;
    label: string;
    brief?: string;
  }[];
}
export default function CheckboxGroup({
  label,
  name,
  id,
  options,
  error,
  orientation = 'vertical',
  ...rest
}: CheckboxGroupProps) {
  return (
    <>
      <label htmlFor={id} className='block text-sm font-medium text-gray-700'>
        {label}
      </label>
      <div className='space-y-2'>
        <legend className='sr-only'>{label}</legend>
        <div
          className={orientation === 'horizontal' ? 'flex flex-wrap gap-5' : ''}
        >
          <ReactCheckboxGroup id={id} name={name} {...rest}>
            {(Checkbox: any) => {
              return (
                <>
                  {options?.map((option, index) => {
                    const { value, label, brief } = option;
                    const innerId = `${id}-${index}`;
                    return (
                      <div
                        key={value}
                        className='flex items-center gap-2 py-0.5'
                      >
                        <Checkbox
                          id={innerId}
                          type='checkbox'
                          className='h-5 w-5 form-checkbox'
                          value={value}
                        />
                        <div className='text-sm'>
                          {label && (
                            <label
                              htmlFor={innerId}
                              className='font-medium text-gray-700'
                            >
                              {label}
                            </label>
                          )}
                          {brief && (
                            <p
                              id={`${innerId}-brief`}
                              className='text-gray-500'
                            >
                              {brief}
                            </p>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </>
              );
            }}
          </ReactCheckboxGroup>
        </div>
      </div>
      {error && <InputError>{error}</InputError>}
    </>
  );
}
